import './footer.css';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Footer = () => {

    const { t } = useTranslation();

    return (
        <div className="barmatch_footer">
            <div className="contact-parent">
                <div className="contact-child" id="questions-child">
                    <h4>{t('Questions')}</h4>
                </div>
                <div className="contact-child" id="faq-contact-child">
                    <p>
                        {t('FooterText1')} <Link to="/#faq" className="links"> {t('FooterText2')} </Link> {t('FooterText3')}
                        <Link to="/kontakt" className="links"> {t('FooterText4')} </Link> {t('FooterText5')}
                    </p>
                </div>
                <div className="contact-child" id="social-media-child">
                    <div className="follow-child2">
                        <p>&#10148; @BarMatch.germany </p>
                    </div>
                    <div className="buttons-child2">
                        <a href="https://www.facebook.com/profile.php?id=61588254565353" className="social-media-button">
                            <FaFacebook color={'#FFFFFF'} title="Facebook" />
                        </a>

                        <a href="https://www.instagram.com/barmatch.germany/" className="social-media-button">
                            <FaInstagram color={'#FFFFFF'} title="Instagram" />
                        </a>

                        <a href="https://www.twitter.com/" className="social-media-button">
                            <FaTwitter color={'#FFFFFF'} title="Twitter" />
                        </a>
                    </div>
                </div>
            </div>

            <div className="impressum">
                <Link to="/impressum"><h4 className="links">{t('Imprint')}</h4></Link>
                <Link to="/datenschutz"><h4 className="links">{t('PrivacyPolicy')}</h4></Link>
                <p>
                    {t('Contact1')}
                    <br />
                    {t('Contact2')}
                    <br />
                    {t('Contact3')}
                </p>
            </div>
        </div>
    )
}

export default Footer;